module.exports = __webpack_public_path__ + "img/3.c5e94c49.jpg";